import React from 'react';
import { useLocation } from 'react-router-dom'; // Import useLocation
import '../css/GiftcardRenewalSuccess.css'; // Import the CSS file

function GiftcardRenewalSuccess() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const ticket = queryParams.get('ticket');
  const expiration = queryParams.get('expiration');

  return (
    <div className="giftcard-renewal-success-container">
      <div className="logo-container">
        <img src={`${process.env.REACT_APP_ASSETS_URL}/logo.png`} alt="Logo" className="logo" />
      </div>
      <h1>:)</h1>
      <h3>La Gift Card <strong>{ticket}</strong> è stata rinnovata con successo fino al <strong>{expiration}</strong></h3>
      <button className="button" onClick={() => window.location.href=`${process.env.REACT_APP_WEBSITE_BASE_URL}/eventi`}>
        Prenota un Evento
      </button>
    </div>
  );
}

export default GiftcardRenewalSuccess; 